import $ from 'jquery';
import { Feature, Overlay } from 'ol';
import 'ol-ext/dist/ol-ext.css';
import { Image, Vector } from 'ol/layer';
import 'ol/ol.css';
import { CloseMessage, ReadyMessage } from '../lib/messages';
import { EPSG, declared_wkids, extract_wkid, first_registered_wkid, read_wkid } from '../lib/projection';
import { LayerUIFactory } from '../lib/ui/layer';
import { GSAContextManager } from './gsa/GSAContextManager';
import { GSADispatcher } from './gsa/GSADispatcher';
import { GSAInteractionManager } from './gsa/GSAInteractionManager';
import { GSALayers } from "./gsa/GSALayers";
import { GSAMap } from './gsa/GSAMap';
import { GSAToolbar } from './gsa/GSAToolbar';
import { BaseLayerBox } from './layerbox/BaseLayerBox';
import { OverlayLayerBox } from './layerbox/OverlayLayerBox';
import { ThematicLayerBox } from './layerbox/ThematicLayerBox';
import { EsriJSON } from 'ol/format';
import { transform, transformExtent } from 'ol/proj';
const DEBUG = false;
const debug_setup = (map, p_layer, ctx_mgr, i_mgr) => {
    console.info("Debug enabled. Available: map, parcelLayer, contextManager, interactionManager");
    window.map = map;
    window.parcelLayer = p_layer;
    window.contextManager = ctx_mgr;
    window.interactionManager = i_mgr;
};
document.body.oncontextmenu = (e) => e.preventDefault();
const run = async (view) => {
    if (Config.MultipleBaseLayersEnabled) {
        LayerUIFactory.multiBaseLayersEnabled = true;
    }
    if (Config.KmlDownloadEnabled == false) {
        LayerUIFactory.kmlDownloadEnabled = false;
    }
    else {
        LayerUIFactory.kmlDownloadEnabled = true;
    }
    const map = await GSAMap.build(Config, view);
    let overlay_box = new OverlayLayerBox({ render_index: 2, ui_index: 1 });
    let baselayer_box = new BaseLayerBox({ render_index: 0, ui_index: 0 }, Config.MultipleBaseLayersEnabled);
    let thematic_layer_box = new ThematicLayerBox({ render_index: 1, ui_index: 2 });
    map.add_layerbox_components(baselayer_box, thematic_layer_box, overlay_box);
    await map.loaded();
    overlay_box.label_layers.map(l => {
        if (l.visible) {
            map.addLayer(l.raw.unwrap());
            return l;
        }
        ;
    }).map(l => { if (l) {
        l.visible = true;
    } });
    const parcel_layer = GSALayers.parcel(view, GSAMap.config, map);
    const marker_layer = GSALayers.marker(parcel_layer);
    const sketch_layer = GSALayers.sketch;
    const group_layer = GSALayers.group;
    const measurement_layer = GSALayers.measure;
    const zoombox_layer = GSALayers.zoombox;
    const buffer_layer = GSALayers.buffer(parcel_layer, GSAMap.config);
    const loc_layer = GSALayers.location(parcel_layer, GSAMap.config, map);
    map.add_selection_layer(parcel_layer);
    map.add_client_layers(marker_layer, sketch_layer, group_layer, measurement_layer, zoombox_layer, buffer_layer, loc_layer);
    const ctx_manager = new GSAContextManager(map, parcel_layer, marker_layer, buffer_layer);
    const interaction_manager = new GSAInteractionManager(map, parcel_layer, sketch_layer);
    const toolbar = new GSAToolbar(parcel_layer, buffer_layer, loc_layer);
    map.addControl(toolbar);
    const dispatcher = new GSADispatcher(map, parcel_layer, sketch_layer, marker_layer, buffer_layer, ctx_manager);
    if (DEBUG)
        debug_setup(map, parcel_layer, ctx_manager, interaction_manager);
    ctx_manager.update_context('singleton');
    map.ready();
    const map_pointer_handler = (event) => {
        if (event.dragging)
            return;
        const pixel = map.getEventPixel(event.originalEvent);
        let features = map.get_features_at_pixel(pixel);
        let r_features = features.filter(v => v[1] === parcel_layer.raw).map(v => v[0]);
        if (r_features.length === 0) {
            $('#status-content').remove();
            parcel_layer.hovered = '';
            return;
        }
        const f = r_features[0];
        parcel_layer.hovered = f.get(parcel_layer.identifier);
        let content = $('<div id="status-content"></div>');
        if (parcel_layer.colorized) {
            const field = parcel_layer.color_manager.fields.selected.unwrapOr('');
        }
        else {
        }
        $('#status-content').remove();
        $('#status-bar').append(content);
    };
    const handle_parcel_click = (coord, alt) => {
        ctx_manager.context.map(c => c.click_handler(coord, alt));
    };
    const identify_label_layer_features = async (coordinate) => {
        var _a;
        const layers = map.getLayers().getArray().map(l => {
            var _a, _b;
            if ((l instanceof Image) && l.getVisible() === true) {
                const layer = l;
                const source = layer.getSource();
                const layer_num = (_a = source === null || source === void 0 ? void 0 : source.getParams()) === null || _a === void 0 ? void 0 : _a.LAYERS;
                if (!layer_num)
                    return null;
                const parts = layer_num.split(':');
                if (parts.length < 2)
                    return null;
                const ids = parts[1].split(',').map((id) => id.trim());
                return { url: (_b = source.getUrl()) !== null && _b !== void 0 ? _b : '', layer_ids: ids, layer_name: layer.get('name') };
            }
            return null;
        });
        const layers_combined = [];
        const unique_urls = new Set();
        layers.forEach(x => {
            if (x === null)
                return;
            if (unique_urls.has(x.url)) {
                const item = layers_combined.find(y => y.url === x.url);
                const layer_info = { layer_name: x.layer_name, layer_ids: [...x.layer_ids] };
                item.layers_info.push(layer_info);
            }
            else {
                unique_urls.add(x.url);
                const layers_info = [{ layer_name: x.layer_name, layer_ids: [...x.layer_ids] }];
                layers_combined.push({ url: x.url, layers_info });
            }
        });
        const mapProj = map.getView().getProjection().getCode();
        const mapProjWkid = extract_wkid(mapProj);
        let features = await Promise.all(layers_combined.map(async (l) => {
            var _a, _b;
            if (l.url && l.layers_info.length) {
                const layer_ids = l.layers_info.map((x) => x.layer_ids).flat();
                const identifyUrl = l.url.replace(/\/MapServer\/?$/, '/MapServer/identify');
                const size = (_a = map.getSize()) !== null && _a !== void 0 ? _a : [1200, 800];
                const mapWkid = mapProjWkid;
                const firstLayerId = layer_ids[0];
                const layerUrl = l.url.replace(/\/MapServer\/?$/, `/MapServer/${firstLayerId}`);
                const layer_sr = await get_layer_spatial_reference(layerUrl);
                const usableLayerWkid = first_registered_wkid(...layer_sr.declared);
                if (layer_sr.native.length && !first_registered_wkid(...layer_sr.native)) {
                    console.warn(`Layer spatial reference ${layer_sr.native.join('/')} is not registered in the GIS config's Projections section; requesting identify in ${(_b = usableLayerWkid !== null && usableLayerWkid !== void 0 ? usableLayerWkid : mapWkid) !== null && _b !== void 0 ? _b : 3857} instead. Add it to the Projections section to query the layer in its own spatial reference.`);
                }
                const view_extent = map.getView().calculateExtent(map.getSize());
                let targetWkid = usableLayerWkid || mapWkid || 3857;
                const targetProj = `EPSG:${targetWkid}`;
                let queryCoordinate = coordinate;
                let queryExtent = view_extent;
                if (mapProj !== targetProj) {
                    try {
                        const converted = transform(coordinate, mapProj, targetProj);
                        if (!converted.every(Number.isFinite)) {
                            throw new Error(`the Projections entry for EPSG:${targetWkid} produced no usable coordinates - check it, e.g. an unavailable +nadgrids file`);
                        }
                        const converted_extent = transformExtent(view_extent, mapProj, targetProj);
                        if (!converted_extent.every(Number.isFinite)) {
                            throw new Error(`the Projections entry for ${targetProj} produced no usable extent`);
                        }
                        queryCoordinate = converted;
                        queryExtent = converted_extent;
                    }
                    catch (err) {
                        console.warn(`Could not express the click and map extent in ${targetProj}, requesting in the map projection instead`, err);
                        queryCoordinate = coordinate;
                        queryExtent = view_extent;
                        targetWkid = mapWkid || 3857;
                    }
                }
                const request_identify = async (request_coordinate, request_extent, request_wkid) => {
                    var _a;
                    const params = new URLSearchParams({
                        f: 'json',
                        tolerance: '5',
                        returnGeometry: 'true',
                        imageDisplay: `${size[0]},${size[1]},96`,
                        mapExtent: request_extent.join(','),
                        geometry: JSON.stringify({
                            x: request_coordinate[0],
                            y: request_coordinate[1],
                            spatialReference: { wkid: request_wkid },
                        }),
                        geometryType: 'esriGeometryPoint',
                        sr: request_wkid.toString(),
                        layers: `visible:${layer_ids.join(',')}`,
                    });
                    try {
                        const res = await fetch(`${identifyUrl}?${params}`);
                        if (!res.ok) {
                            console.warn(`Identify request failed with status ${res.status} for ${identifyUrl}`);
                            return null;
                        }
                        const data = await res.json();
                        if (data.error) {
                            console.warn('ArcGIS identify error:', data.error);
                            return null;
                        }
                        return (_a = data.results) !== null && _a !== void 0 ? _a : [];
                    }
                    catch (err) {
                        console.error('Identify request failed:', err);
                        return null;
                    }
                };
                let results = await request_identify(queryCoordinate, queryExtent, targetWkid);
                let resultsWkid = targetWkid;
                if (mapWkid && mapWkid !== targetWkid && (!results || results.length === 0)) {
                    const fallback_results = await request_identify(coordinate, view_extent, mapWkid);
                    if (fallback_results && fallback_results.length > 0) {
                        results = fallback_results;
                        resultsWkid = mapWkid;
                    }
                }
                if (results && results.length > 0) {
                    const unique_results = new Set();
                    return results.filter((x) => {
                        var _a, _b, _c, _d;
                        let custom_layer_name = '';
                        for (const i of l.layers_info) {
                            if (i.layer_ids.includes(x.layerId.toString())) {
                                custom_layer_name = i.layer_name;
                                break;
                            }
                        }
                        x.custom_layer_name = custom_layer_name;
                        const echoed_sr = (_a = x === null || x === void 0 ? void 0 : x.geometry) === null || _a === void 0 ? void 0 : _a.spatialReference;
                        x.custom_geometry_wkid = (_b = read_wkid(echoed_sr)) !== null && _b !== void 0 ? _b : resultsWkid;
                        x.custom_geometry_wkid_echoed = (_c = declared_wkids(echoed_sr)[0]) !== null && _c !== void 0 ? _c : null;
                        const fid = (_d = x === null || x === void 0 ? void 0 : x.attributes) === null || _d === void 0 ? void 0 : _d.FID;
                        if (!fid)
                            return true;
                        if (unique_results.has(fid)) {
                            return false;
                        }
                        unique_results.add(fid);
                        return true;
                    });
                }
                else {
                    return [];
                }
            }
            else {
                return [];
            }
        }));
        features = features.flat();
        const feautreMap = new Map();
        for (const feature of features) {
            const fid = (_a = feature === null || feature === void 0 ? void 0 : feature.attributes) === null || _a === void 0 ? void 0 : _a.FID;
            if (!fid) {
                feature.additional_layer_names = [];
                feautreMap.set(Symbol(), feature);
                continue;
            }
            if (!feautreMap.has(fid)) {
                feature.additional_layer_names = feature.additional_layer_names || [];
                feautreMap.set(fid, feature);
            }
            else {
                const f = feautreMap.get(fid);
                f.additional_layer_names.push(feature.custom_layer_name);
            }
        }
        features = [...feautreMap.values()];
        const container = $('<div></div>');
        features.forEach((result) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const geometryWkid = result === null || result === void 0 ? void 0 : result.custom_geometry_wkid;
            if ((result === null || result === void 0 ? void 0 : result.custom_geometry_wkid_echoed) && result.custom_geometry_wkid_echoed !== geometryWkid) {
                console.warn(`Identify returned geometry in WKID ${result.custom_geometry_wkid_echoed}, which is not registered in the GIS config's Projections section; reading it as ${geometryWkid} instead. Geometry and KML export for this feature may be misplaced. Add WKID ${result.custom_geometry_wkid_echoed} to the Projections section.`);
            }
            let geometry = null;
            if (result === null || result === void 0 ? void 0 : result.geometry) {
                try {
                    geometry = new EsriJSON().readGeometry(result.geometry, {
                        dataProjection: EPSG(geometryWkid),
                        featureProjection: mapProj,
                    });
                }
                catch (err) {
                    console.warn(`Could not read geometry in WKID ${geometryWkid}; showing this feature's attributes only`, err);
                }
            }
            const feature = new Feature({ geometry });
            const feature_name = (_f = (_d = (_b = (_a = result === null || result === void 0 ? void 0 : result.attributes) === null || _a === void 0 ? void 0 : _a[Config.ParcelIdentifierColumn]) !== null && _b !== void 0 ? _b : (_c = result === null || result === void 0 ? void 0 : result.attributes) === null || _c === void 0 ? void 0 : _c["FID"]) !== null && _d !== void 0 ? _d : (_e = result === null || result === void 0 ? void 0 : result.attributes) === null || _e === void 0 ? void 0 : _e["OBJECTID"]) !== null && _f !== void 0 ? _f : result.layerName;
            const section = $(`<details class="feature-info-section"></details>`);
            const layer_name = (_g = result === null || result === void 0 ? void 0 : result.custom_layer_name) !== null && _g !== void 0 ? _g : result.layerName;
            const other_layers = [layer_name, ...result.additional_layer_names].join(', ').trim();
            const section_header = $(`<summary class="feature-info-section-header" title="${other_layers}"><h5>${layer_name.trim()}</h5></summary>`);
            const kml_available = !!geometry;
            const btn = $(`<button class="kml-download-btn${kml_available ? '' : ' kml-unavailable-btn'}" title="Download KML for ${feature_name}"></button>`);
            const download_img = $(`<i class="fas ${kml_available ? 'fa-download' : 'fa-exclamation-triangle'}"></i>`);
            btn.append(download_img);
            if (kml_available) {
                btn.on('click', (_) => {
                    map.download_kml_data([feature], feature_name);
                });
            }
            const span = $(`<span class="kml-download-span">KML</span>`);
            btn.append(span);
            if (kml_available) {
                section_header.append(btn);
            }
            else {
                btn.removeAttr('title');
                btn.prop('disabled', true);
                section_header.append($('<span class="kml-unavailable-slot" title="KML unavailable for feature"></span>').append(btn));
            }
            section.append(section_header);
            if (result.attributes) {
                process_attributes(result.attributes, section);
            }
            else {
                process_attributes(result, section);
            }
            container.append(section);
        });
        return container;
    };
    const get_vector_layer_features = (pixel) => {
        const container = $('<div></div>');
        map.get_features_at_pixel(pixel).forEach(x => {
            var _a;
            const feature = x[0];
            const layer = x[1];
            if (!layer || !feature) {
                return;
            }
            const name = layer.get('name');
            if (name && (layer instanceof Vector)) {
                const f = feature;
                const feature_name = (_a = f.get(Config.ParcelIdentifierColumn)) !== null && _a !== void 0 ? _a : name;
                const section = $(`<details class="feature-info-section"></details>`);
                const section_header = $(`<summary class="feature-info-section-header"><h5>${name}</h5></summary>`);
                const btn = $(`<button class="kml-download-btn" title="Download KML for ${feature_name}"></button>`);
                const download_img = $(`<i class="fas fa-download"></i>`);
                btn.append(download_img);
                btn.on('click', (_) => {
                    map.download_kml_data([f], feature_name);
                });
                const span = $(`<span class="kml-download-span">KML</span>`);
                btn.append(span);
                section_header.append(btn);
                section.append(section_header);
                f.getKeys().map(k => {
                    if (k === "geometry")
                        return;
                    let v = f.get(k);
                    if (!v)
                        return;
                    section.append(create_info_row(k, v));
                });
                container.append(section);
            }
        });
        return container;
    };
    const create_info_row = (title, value) => {
        let isUrl = false;
        let anchorTag = '';
        try {
            const url = new URL(value.trim());
            isUrl = true;
            anchorTag = `<a href="${url}" target="_blank">${value}</a>`;
        }
        catch (_) { }
        let label = $(`<div class="feature-info-row"><strong>${title}:</strong> ${isUrl ? anchorTag : value}</div>`);
        return label;
    };
    const process_attributes = (attributes, section) => {
        Object.entries(attributes)
            .map(([k, v]) => {
            if (typeof v === 'string' && v.trim().toLowerCase() !== 'null' && v.trim().length) {
                section.append(create_info_row(k, v));
            }
        });
    };
    const get_layer_spatial_reference = async (layerUrl) => {
        var _a;
        try {
            const res = await fetch(`${layerUrl}?f=json`);
            if (!res.ok)
                return { native: [], declared: [] };
            const data = await res.json();
            const native = declared_wkids(data === null || data === void 0 ? void 0 : data.sourceSpatialReference);
            const declared = [
                ...native,
                ...declared_wkids(data === null || data === void 0 ? void 0 : data.spatialReference),
                ...declared_wkids((_a = data === null || data === void 0 ? void 0 : data.extent) === null || _a === void 0 ? void 0 : _a.spatialReference),
            ].filter((wkid, index, all) => all.indexOf(wkid) === index);
            return { native, declared };
        }
        catch (err) {
            console.warn('Could not fetch layer spatial reference:', err);
            return { native: [], declared: [] };
        }
    };
    map.on('pointermove', evt => {
        ctx_manager.context
            .filter(c => !c.has_measure || c.name === 'group')
            .mapOr(interaction_manager.pointer_handler(evt), _ => map_pointer_handler(evt));
    });
    map.on('click', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let b = $(evt.originalEvent.target).closest('button.tooltip-close-button');
            if (b.length) {
                b.trigger('click');
                evt.stopPropagation();
                return;
            }
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
        if (!sketch_layer.isLayerActive) {
            ctx_manager.context
                .filter(c => !c.has_measure)
                .map(_ => handle_parcel_click(evt.coordinate, evt.originalEvent.shiftKey));
        }
    });
    map.getViewport().addEventListener('contextmenu', async (evt) => {
        if (!Config.DisplayRightClickPopup)
            return;
        evt.preventDefault();
        const pixel = map.getEventPixel(evt);
        const coordinate = map.getCoordinateFromPixel(pixel);
        if (evt.target instanceof Element) {
            let popup = $(evt.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
        const box = $('#feature-info-box');
        box.html('');
        box.append($(`<div class="feature-info-title"><h5>Feature(s) Info</h5><button class="tooltip-close-button"><i class="fas fa-times" title="Close"></i></button></div>`));
        $('.feature-info-title button').on('click', () => { box.addClass('hidden'); });
        let content = $(`<div id="feature-info-content"></div>`);
        box.append(content);
        const label_layer_features_html = await identify_label_layer_features(coordinate);
        if (label_layer_features_html.children().length) {
            content.append(label_layer_features_html);
        }
        const vector_layer_features_html = get_vector_layer_features(pixel);
        if (vector_layer_features_html.children().length) {
            content.append(vector_layer_features_html);
        }
        if (!content.children().length) {
            box.addClass('hidden');
        }
        else {
            const popup = new Overlay({
                element: box.get(0),
                position: coordinate,
                positioning: calculate_positioning(),
                stopEvent: false,
            });
            map.addOverlay(popup);
            box.removeClass('hidden');
        }
        function calculate_positioning() {
            var _a, _b;
            let box_width = (_a = box.width()) !== null && _a !== void 0 ? _a : 270;
            let box_height = (_b = box.height()) !== null && _b !== void 0 ? _b : 300;
            let map_width = map.getSize() ? map.getSize()[0] : 0;
            let map_height = map.getSize() ? map.getSize()[1] : 0;
            let r_box_width = box_width + evt.clientX;
            let r_box_height = box_height + evt.clientY;
            if (r_box_width >= map_width && r_box_height >= map_height) {
                return "bottom-right";
            }
            else if (r_box_height >= map_height) {
                return "bottom-left";
            }
            else if (r_box_width >= map_width) {
                return "top-right";
            }
            else {
                return "top-left";
            }
        }
    });
    map.on('wheel', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
    });
    map.on('pointerdrag', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
    });
    map.on('dblclick', (evt) => {
        if (evt.originalEvent.target instanceof Element) {
            let popup = $(evt.originalEvent.target).closest('#feature-info-box');
            if (popup.length) {
                evt.stopPropagation();
                return;
            }
        }
    });
    map.once('rendercomplete', _ => {
        if (Config.DisplayLayersListBox) {
            toolbar.display_layers_list();
        }
    });
    $(window).on('message', (msg) => {
        const message = msg.originalEvent;
        if (message.data.command !== 'SET VIEW') {
            dispatcher.dispatch(message.data);
        }
    }).on('beforeunload', () => {
        CloseMessage.send();
    });
};
window.addEventListener('message', msg => {
    if (msg.data.command === 'SET VIEW') {
        if (window.map)
            delete window.map;
        $('#map').html('<div id="popup"></div>');
        $('#layerbox').html('');
        $('#thematicbox').html('');
        run(msg.data.view);
    }
});
window.onload = () => setTimeout(() => ReadyMessage.send(), 250);
